import apiFetch from '../apiFetch'

export default function (idValidacionMateriaPrima, token) {
  return apiFetch({endPoint: `ValidacionMateriaPrima/getValidacionMateriaPrima?idValidacionMateriaPrima=` + idValidacionMateriaPrima, method: 'GET', body: null, token: token})
}